import { DateTime } from 'luxon';
import { DESIGN_HUDDLE_DOMAIN } from './index';
import { TokenPayload } from '../types';

export const TOKEN_STORAGE_KEY = 'dh_token';

export const checkForTokenExpired = (expiresAt: string): boolean => {
  return DateTime.now() >= DateTime.fromISO(expiresAt);
};

export const getStoredToken = (): TokenPayload | null => {
  try {
    const rawToken = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (!rawToken) return null;
    return JSON.parse(rawToken) as TokenPayload;
  } catch {
    return null;
  }
};

export const persistToken = (accessToken: string, expiresIn: number, email: string): TokenPayload => {
  const expiresAt = DateTime.now().plus({ seconds: expiresIn }).toISO();
  const tokenPayload = { accessToken, expiresAt, email };
  localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(tokenPayload));

  return tokenPayload;
};

export const configureDesignHuddleLib = (accessToken: string, customizationsHash?: string) => {
  const config = {
    domain: DESIGN_HUDDLE_DOMAIN,
    access_token: accessToken,
    ...(customizationsHash && { template_customization_object_hash: customizationsHash }),
  };

  window.DSHDLib.configure(config);
};